module.exports = __webpack_public_path__ + "static/US1_traditional-0d96c02fb15d3721be229b1d0e6912f5.png";